import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import "./FilterModal.css";

const FilterModal = ({ isOpen, onClose, columnData, columnName, applyFilter, selectedValues, setSelectedValues }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const handleCheckboxChange = (value, columnName) => {
    let newSelectedValues = selectedValues[columnName]?.includes(value)
      ? {
          ...selectedValues,
          [`${columnName}`]: selectedValues[columnName].filter((item) => item !== value),
        }
      : {
          ...selectedValues,
          [`${columnName}`]: [...(selectedValues[columnName] || []), value],
        };

    setSelectedValues(newSelectedValues);
  };

  const handleApplyFilter = () => {
    applyFilter(columnName, selectedValues);
    onClose();
  };

  const handleReset = () => {
    setSelectedValues((prev) => ({
      ...prev,
      [columnName]: [],
    }));
  };

  const filteredData = columnData.filter((item) => item.toLowerCase().includes(searchTerm));

  return (
    <Modal open={isOpen} onClose={onClose}>
      <div className="filter-modal">
        {/* <h4>Filter by {columnName}</h4> */}
        <div className="filter-search-container">
          <input
            type="search"
            placeholder="Search..."
            value={searchTerm}
            onChange={handleSearch}
            className="filter-search"
          />
        </div>
        <div className="filter-options">
          {filteredData.map((value, index) => (
            <div key={index} className="filter-option">
              <input
                type="checkbox"
                checked={selectedValues[columnName]?.includes(value)}
                onChange={() => handleCheckboxChange(value, columnName)}
              />
              <label>{value}</label>
            </div>
          ))}
        </div>
        <div className="filter-actions">
          <button className="reset-button" onClick={handleReset}>
            Reset
          </button>
          <div className="filter-action-buttons">
            <button onClick={handleApplyFilter}>Apply</button>
            <button onClick={onClose}>Cancel</button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FilterModal;
